import { useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { hasAnyRole } from "../../auth/rbac";
import type { Role } from "../../api/types";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

/** Kimlik doğrulaması gerektiren korumalı yerleşim. */
export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div
        className="text-muted-foreground flex min-h-screen items-center justify-center text-sm"
        role="status"
      >
        Yükleniyor…
      </div>
    );
  }
  if (status === "anonymous") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <AppLayout />;
}

/** Rol bazlı koruma (ör. kullanıcı yönetimi yalnızca admin). */
export function RequireRole({ roles, children }: { roles: readonly Role[]; children: React.ReactNode }) {
  const { user } = useAuth();
  if (!hasAnyRole(user?.role, roles)) {
    return (
      <div role="alert" className="bg-danger/10 text-danger rounded-lg border border-danger/30 p-6 text-sm">
        Bu sayfayı görüntüleme yetkiniz yok. Gerekli rol: {roles.join(", ")}.
      </div>
    );
  }
  return <>{children}</>;
}

function AppLayout() {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="bg-background flex min-h-screen">
      <Sidebar
        role={user?.role}
        open={sidebarOpen}
        onNavigate={() => setSidebarOpen(false)}
      />
      {sidebarOpen ? (
        <button
          type="button"
          aria-label="Menüyü kapat"
          className="fixed inset-0 z-20 bg-black/40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      ) : null}
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar onToggleSidebar={() => setSidebarOpen((open) => !open)} />
        <main className="flex-1 p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}